import { getDateTime } from 'infras/datetime';
import { post } from 'infras/rest_client';
import Cookie from 'js-cookie';
import { apiPath } from 'presentations/routes/path';
import { useEffect } from 'react';
import { nanoid } from 'nanoid';

export interface LocalCampaign {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
}

export const getOptions = () => {
  let domain = 'localhost';
  const isProduction = process.env['NODE_ENV'] === 'production';
  if (isProduction) {
    const build = process.env['BUILD_ENV'];
    domain = build === 'production' ? '.jicoo.com' : '.jicoo.dev';
  }

  const expires = getDateTime().plus({ year: 1 }).toJSDate();

  return {
    domain,
    secure: isProduction,
    expires,
  };
};

export const setSourceTrack = (props: LocalCampaign = {}) => {
  const options = getOptions();
  if (!Cookie.get('uuid')) {
    Cookie.set('uuid', nanoid(), options);
  }

  if (Cookie.get('cp_su')) return;
  if (Cookie.get('cp_s')) return;

  const url = new URL(window.location.href);
  const currentSec = String(getDateTime().toSeconds());

  let source = url.searchParams.get('utm_source');
  if (!source) {
    if (document.referrer) {
      source = 'referrer';
    } else {
      source = 'direct';
    }
  }
  if (props && props.source) source = props.source;
  Cookie.set('cp_s', source, options);

  let medium = url.searchParams.get('utm_medium');
  if (props && props.medium) medium = props.medium;
  if (medium) Cookie.set('cp_m', medium, options);

  let campaign = url.searchParams.get('utm_campaign');
  if (props && props.campaign) campaign = props.campaign;
  if (campaign) Cookie.set('cp_n', campaign, options);

  let term = url.searchParams.get('utm_term');
  if (props && props.term) term = props.term;
  if (term) Cookie.set('cp_t', term, options);

  let content = url.searchParams.get('utm_content');
  if (props && props.content) content = props.content;
  if (content) Cookie.set('cp_c', content, options);
  Cookie.set('cp_r', document.referrer, options);
  if (document.referrer) {
    Cookie.set('cp_r', document.referrer, options);
  }
  Cookie.set('cp_d', currentSec, options);
  Cookie.set('cp_u', url.pathname, options);
};

export const useSourceTrack = (props: LocalCampaign = {}) => {
  useEffect(() => {
    setSourceTrack(props);
  }, []);
};

export const syncUserSource = async () => {
  if (Cookie.get('cp_su')) return;
  if (!Cookie.get('cp_s')) return;

  const result = await post(apiPath(`/v1/user_sources/create`));
  if (!result.isSuccess) {
    return;
  }
  const options = getOptions();
  Cookie.set('cp_su', '1', {
    ...options,
    expires: getDateTime().plus({ year: 10 }).toJSDate(),
  });
  Cookie.remove('cp_s', options);
  Cookie.remove('cp_r', options);
  Cookie.remove('cp_u', options);
  Cookie.remove('cp_m', options);
  Cookie.remove('cp_n', options);
  Cookie.remove('cp_t', options);
  Cookie.remove('cp_c', options);
  Cookie.remove('cp_u', options);
  Cookie.remove('cp_d', options);
};

export const useReferralTrack = () => {
  useEffect(() => {
    const options = getOptions();
    const url = new URL(window.location.href);
    const referralId = url.searchParams.get('referral');

    if (referralId) {
      Cookie.set('referral', referralId, options);
    }
  }, []);
};
